<template>
  <div>
    <div class="position-relative w-100 d-flex justify-content-center">
      <div class="toolbar-editor-wrp position-relative d-table">
        <div class="d-table-row">
          <div class="d-table-cell align-middle border-right-gray">
            <div class="toolbar-editor-group1 d-table">
              <div class="d-table-row">
                <div v-if="!isHideFontName" class="d-table-cell">
                  <div class="mr-2">
                    <v-select
                      v-model="formData.fontName"
                      class="vselect-editor-custom normal-size"
                      :searchable="true"
                      placeholder="Font"
                      :options="optionData.fontList"
                    >
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"
                          ><img
                            width="10"
                            height="auto"
                            src="https://cdn.discordapp.com/attachments/938004511274975272/984002804509204490/down-filled-triangular-arrow.png"
                        /></span>
                      </template>
                      <template #option="option">
                        <div class="d-block w-100 text-wrap">
                          {{ option.label }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div v-if="!isHideFontSize" class="d-table-cell">
                  <div class="mr-2">
                    <v-select
                      v-model="formData.fontSize"
                      class="vselect-editor-custom small-size"
                      :searchable="false"
                      placeholder="Size"
                      :options="optionData.fontSizeList"
                    >
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"
                          ><img
                            width="10"
                            height="auto"
                            src="https://cdn.discordapp.com/attachments/938004511274975272/984002804509204490/down-filled-triangular-arrow.png"
                        /></span>
                      </template>
                      <template #option="option">
                        <div class="d-block w-100 text-wrap">
                          {{ option.label }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isHideFontStyle"
            class="d-table-cell align-middle border-right-gray"
          >
            <div class="toolbar-editor-group2 mr-2 ml-2">
              <div class="d-table">
                <div class="d-table-row">
                  <div
                    v-for="item in optionData.fontStyle"
                    :key="item.id"
                    class="d-table-cell"
                  >
                    <b-button
                      class="btn-text-editor"
                      :class="[
                        formData.fontStyle.findIndex(
                          (itemName) => itemName == item.value
                        ) !== -1
                          ? 'active'
                          : '',
                      ]"
                      @click="onSelectFontStyle(item)"
                    >
                      <feather-icon
                        :icon="`${item.label}Icon`"
                        size="14"
                        class="text-black"
                      />
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isHideLineHeight"
            class="d-table-cell align-middle border-right-gray"
          >
            <div class="position-relative mt-1 ml-1 mr-2">
              <b-button
                class="btn-text-editor position-absolute z-1 bypass"
                :class="[{ active: formData.lineHeight }]"
              >
                <img :src="TextHeightIcon" alt="" width="15" />
              </b-button>
              <v-select
                v-model="formData.lineHeight"
                class="vselect-linehight small-size"
                :searchable="false"
                placeholder=""
                :options="optionData.lineHeight"
                closeOnSelect
                :clearable="false"
                :reduce="(option) => option.value"
              >
                <template #open-indicator="{ attributes }">
                  <span class="d-none" v-bind="attributes"
                    ><img
                      width="10"
                      height="auto"
                      src="https://cdn.discordapp.com/attachments/938004511274975272/984002804509204490/down-filled-triangular-arrow.png"
                  /></span>
                </template>
                <template #option="option">
                  <div class="d-block w-100 text-wrap">
                    {{ option.label }}
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <div
            v-if="!isHideFontAlign"
            class="d-table-cell align-middle border-right-gray"
          >
            <div class="toolbar-editor-group3 mr-2 ml-2">
              <div class="d-table">
                <div class="d-table-row">
                  <div
                    v-for="item in optionData.fontAlign"
                    :key="item.id"
                    class="d-table-cell"
                  >
                    <b-button
                      class="btn-text-editor"
                      :class="[
                        formData.fontAlign == item.value ? 'active' : '',
                      ]"
                      @click="formData.fontAlign = item.value"
                    >
                      <feather-icon
                        :icon="`Align${item.label}Icon`"
                        size="14"
                        class="text-black"
                      />
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isHideFontColor" class="d-table-cell align-middle">
            <div class="toolbar-editor-group4">
              <b-form-input
                id="color-code-editor"
                v-model="formData.fontColor"
                class="ml-1 mr-1"
                required
                type="color"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  onBeforeMount,
  onUpdated,
  reactive,
  ref,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import vSelect from "vue-select";

import TextHeightIcon from "@/assets/images/icons/text-height.png";

export default {
  components: { vSelect },
  props: {
    editorData: { type: Object, default: null },
    isHideFontName: { type: Boolean, default: false },
    isHideFontSize: { type: Boolean, default: false },
    isHideFontStyle: { type: Boolean, default: false },
    isHideFontAlign: { type: Boolean, default: false },
    isHideFontColor: { type: Boolean, default: false },
    isHideLineHeight: { type: Boolean, default: false },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const formData = reactive({
      fontName: null,
      fontSize: null,
      fontStyle: [],
      fontAlign: "left",
      fontColor: "#000000",
      lineHeight: "1.15",
    });

    const optionData = reactive({
      fontList: [
        { label: "DB Helvethaica X", value: "DBHelvethaicaX" },
        { label: "DB Helvethaica X 57 Cond", value: "DBHelvethaicaX57Cond" },
        { label: "DB Helvethaica X Med Cond", value: "DBHelvethaicaXMedCond" },
        { label: "DB Helvethaica X 45 Li", value: "DBHelvethaicaX45Li" },
      ],
      fontSizeList: [
        "8",
        "9",
        "10",
        "11",
        "12",
        "14",
        "16",
        "18",
        "20",
        "22",
        "24",
        "30",
        "36",
        "48",
        "60",
        "72",
        "96",
      ],
      fontStyle: [
        { label: "Bold", value: "bold", id: "font-style-bold" },
        { label: "Italic", value: "italic", id: "font-style-italic" },
        { label: "Underline", value: "underline", id: "font-style-underline" },
      ],
      fontAlign: [
        { label: "Left", value: "left", id: "font-align-left" },
        { label: "Center", value: "center", id: "font-align-center" },
        { label: "Right", value: "right", id: "font-align-right" },
      ],
      lineHeight: [
        { label: "0.8", value: "0.8", id: "line-heigth-option1" },
        { label: "Single", value: "1", id: "line-heigth-option2" },
        { label: "1.15", value: "1.15", id: "line-heigth-option3" },
        { label: "1.5", value: "1.5", id: "line-heigth-option4" },
        { label: "Double", value: "2", id: "line-heigth-option5" },
      ],
    });

    const onSelectFontStyle = (item) => {
      const fontStyle = item.value;
      var fontStyleList = [...formData.fontStyle];

      const findIndexActive = formData.fontStyle.findIndex(
        (itemName) => itemName == fontStyle
      );

      if (findIndexActive !== -1) {
        fontStyleList.splice(findIndexActive, 1);
      } else {
        fontStyleList.push(item.value);
      }

      formData.fontStyle = [...fontStyleList];
    };

    const initFormData = () => {
      formData.fontName = props.editorData.fontName;
      formData.fontSize = props.editorData.fontSize;
      formData.fontStyle = props.editorData.fontStyle;
      formData.fontAlign = props.editorData.fontAlign;
      formData.fontColor = props.editorData.fontColor;
      formData.lineHeight = props.editorData.lineHeight;
    };

    onBeforeMount(() => {
      if (
        props.editorData &&
        !Object.values(props.editorData).every(
          (x) => x === null || x === "" || x === undefined
        )
      )
        return initFormData();
    });

    watch(
      props.editorData,
      () => {
        if (
          props.editorData &&
          !Object.values(props.editorData).every(
            (x) => x === null || x === "" || x === undefined
          )
        )
          return initFormData();
      },
      { deep: true }
    );

    watch(
      formData,
      () => {
        vm.$nextTick(() => {
          vm.$emit("onChange", formData);
        });
      },
      { deep: true }
    );

    return {
      TextHeightIcon,
      optionData,
      formData,
      onSelectFontStyle,
    };
  },
};
</script>

<style>
.vselect-editor-custom.normal-size {
  width: 150px !important;
}

.vselect-editor-custom.small-size {
  width: 120px !important;
}

.vselect-editor-custom.normal-size .vs__selected-options .vs__selected {
  display: inline-block;
  white-space: nowrap;
  width: 75px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vselect-editor-custom.small-size .vs__selected-options .vs__selected {
  display: inline-block;
  white-space: nowrap;
  width: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vselect-editor-custom.vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0.8rem !important;
  border-bottom-right-radius: 0.8rem !important;
  border-radius: 0.8rem !important;
  border-color: #0dc4d8 !important;
  border-bottom-color: #0dc4d8 !important;
}

.vselect-editor-custom.vs--single .vs__dropdown-toggle {
  padding: 0 6px;
  background: #ffffff;
  border: 1px solid #878787;
}

.vselect-editor-custom .vs__dropdown-toggle .vs__actions,
.vselect-linehight .vs__dropdown-toggle .vs__actions {
  padding: 0;
}

.vselect-editor-custom .vs__dropdown-toggle .vs__selected,
.vselect-linehight .vs__dropdown-toggle .vs__selected {
  margin-top: auto !important;
}

.vselect-linehight.small-size {
  width: 30px !important;
}

.vselect-linehight.vs--single .vs__dropdown-toggle {
  padding: 0 6px;
  background: transparent;
  border: none;
}

.vselect-linehight.vs--open .vs__dropdown-toggle {
  border: none;
  background: transparent;
  box-shadow: none;
}

.vselect-linehight.small-size .vs__selected-options .vs__selected {
  display: none;
}
</style>

<style scoped>
@import "~@/assets/css/fonts.css";

.font-db1 {
  font-family: "DBHelvethaicaX";
}

.font-db2 {
  font-family: "DBHelvethaicaX57Cond";
}

.font-db3 {
  font-family: "DBHelvethaicaXMedCond";
}

.font-db4 {
  font-family: "DBHelvethaicaX45Li";
}

.toolbar-editor-wrp {
  /* background-color: #ebebeb; */
  background-color: #e8ecf1;
  border-radius: 8px;
  padding: 0.5rem 1rem;
}

.toolbar-editor-wrp.toolbar-active {
  background-color: #e8ecf1;
}

.border-right-gray {
  border-right: 1px solid #8f8f8f;
}

.btn-text-editor {
  padding: 8px;
  margin: 0 1px;
  border-color: transparent !important;
  background-color: transparent !important;
  border: none !important;
}

.btn-text-editor.active {
  background-color: #cdd9ea !important;
  border-radius: 6px;
}

.btn-textEditor-group {
  border: none;
}

#color-code-editor {
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 30px;
  height: 32px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
#color-code-editor::-webkit-color-swatch {
  border-radius: 5px;
  border: none;
}
#color-code-editor::-moz-color-swatch {
  border-radius: 5px;
  border: none;
}

.mt-1 {
  margin-top: 0.25rem !important;
}
</style>
